'use strict';

(function (angular) {
    angular.module('zp.news', []);
})(window.angular);